import React, {Component} from 'react';
import adminStyles from './Admin.module.css';

export default class Button extends Component {
    render() {
        return <button className={adminStyles.Button} type={"button"} onClick={e => this.props.onClick(e)}>{this.props.title}</button>
    }
}
